import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {UiPaginationConfig} from './pagination-config.interface';

@Component({
  selector: 'ui-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PaginationComponent {
  @Input() pagination: UiPaginationConfig;
  @Output() changedPage: EventEmitter<number> = new EventEmitter<number>();

  handlePageChange(page: number): void {
    this.changedPage.emit(page);
  }
}
